module.exports = __webpack_public_path__ + "img/gms_6.f43eacf8.png";